import { Component, EventEmitter, HostBinding, Output } from '@angular/core';
import { HistoryModel, HistoryNoteModel, HistoryUpdateModel } from 'src/app/people/models/history';
import { PersonProfileService } from 'src/app/people/profile/person-profile.service';
import { ProfileHistoryProperty, propertyDescription } from '../../models/profileHistoryProperty';
import { AuditEntryState } from '../../models/auditEntryState';

@Component({
  selector: 'scenario-history-sidebar',
  templateUrl: './scenario-history-sidebar.component.html',
  styleUrls: ['./scenario-history-sidebar.component.scss'],
})
export class ScenarioHistorySidebarComponent {
  @Output() close = new EventEmitter();
  @Output() open = new EventEmitter();
  @HostBinding('class.d-none')
  hidden: boolean = true;
  histories: HistoryModel[] = [];
  propertyDescription: (state: string, prop: ProfileHistoryProperty) => string;

  constructor(private personProfileService: PersonProfileService) {
    this.propertyDescription = propertyDescription;
  }

  openHistory = async (personId: string, personScenarioId: string) => {
    this.open.emit();
    this.hidden = false;
    this.histories = [];
    this.histories = filterHistory(
      await this.personProfileService.getPersonScenarioHistory(personId, personScenarioId)
    );
  };

  onClose() {
    this.close.emit();
    this.hidden = true;
  }
  isHistoryUpdate = (history: HistoryModel): HistoryUpdateModel => {
    const update = history as HistoryUpdateModel;
    if (update.properties?.length) {
      return update;
    }
    return null;
  };

  isHistoryNote = (history: HistoryModel): HistoryNoteModel =>
    this.isHistoryUpdate(history) ? null : (history as HistoryNoteModel);

  updateTitle = (history: HistoryUpdateModel) => {
    if (history.stateName == AuditEntryState.EntityAdded) {
      return `Evidence '${history.description}' Added`;
    }
    if (history.stateName == AuditEntryState.EntityModified) {
      return `Evidence '${history.description}' Updated`;
    }
    if (history.stateName == AuditEntryState.EntityDeleted) {
      return `Evidence '${history.description}' Removed`;
    }

    return history.stateName;
  };
}
const filterHistory = (histories: HistoryModel[]): HistoryModel[] => {
  return Array.from(filterHistoryGenerator(histories));
};

function* filterHistoryGenerator(histories: HistoryModel[]): Generator<HistoryModel> {
  for (const history of histories) {
    const update = history as HistoryUpdateModel;
    if (update.properties?.length) {
      //filter EntityAudits we don't care about
      if (update.entityTypeName === 'PersonAttribute') {
        yield history;
      }
    } else {
      yield history; //HistoryNoteModel
    }
  }
}
